import { createContext } from 'react';

const DrawerContext = createContext();

export default DrawerContext;
